import styled from 'styled-components';

interface Props {

}

export default function Header({ }: Props) {
    return (
        <Wrapper>header</Wrapper>
    )
}

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
`